export const getSimilarityColor = (score: number) => {
  if (score < 30) {
    return '#fa5252';
  }

  if (score < 50) {
    return '#ffa94d';
  }

  if (score < 80) {
    return '#37b24d';
  }

  return '#2b8a3e';
};

export const normalizeScoreToPercent = (score?: number | null) => {
  if (typeof score !== 'number' || Number.isNaN(score) || score === null) {
    return null;
  }

  const normalizedScore = Number((score * 100).toFixed(1));

  if (normalizedScore > 100) {
    return 100;
  }

  if (normalizedScore < 0) {
    return 0;
  }

  return normalizedScore;
};
